export default {
  name: 'relay-station-container'
};